import { validateSpouseName } from '../PersonalInfoWorkflowValidator';

const shouldSkip = (
  isGoingForward,
  optionIsMarried,
  personalInfo,
  partnerName,
) =>
  !optionIsMarried ||
  (isGoingForward && validateSpouseName(personalInfo, partnerName)().length === 0);

export default shouldSkip;
